import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.3",
      d: "m4.485 6.828-1.86 1.86a3.709 3.709 0 0 0 .039 5.286 3.7 3.7 0 0 0 2.65 1.127 3.63 3.63 0 0 0 2.635-1.065l1.862-1.86m2.377-2.333 1.861-1.86a3.709 3.709 0 0 0-.039-5.286 3.78 3.78 0 0 0-2.65-1.105 3.67 3.67 0 0 0-2.636 1.065L6.863 4.518m-1.349 6.59 5.584-5.584"
    }, null, -1)
  ]))]))
}
export default { render: render }